import React, {Component} from 'react'
import PropTypes, { object, string } from 'prop-types'
import { connect } from 'react-redux'

// Actions
import { postLine, ESGLevelTypes, ESGScopeTypes } from '../../../../../actions/esg'

// Utils
import { translation } from '../../../../../utils/helpers'// formatCurrency, reverseFormatCurrency
import { reverseFormatCurrency2 } from '../../../../../utils/currency'

// Elements
import Text from '../../../../../shared/elements/text'
import RemoveButton from '../../../../../shared/elements/removeButton'
import TableRow from '../../../../../shared/elements/tableRow'
import AddButton from '../../../../../shared/elements/addButton'
import DecimalInput from '../../../../../shared/components/DecimalInput'

class Lines extends Component {
  constructor (props) {
    super(props)
    this.resetNewLine = {
      Name: '',
      EntryValue: '',
      UnitValue: '',
      AmountPrUnit: 0
    }
    this.maxDecimals = 3 // maybe a precice conversion is needed

    this.state = {
      newLine: {
        ...this.resetNewLine
      }
    }
  }

  render () {
    let scopeType = this.props.scopeType

    const renderLine = (line, index) => {
      const changeLineData = (data, shouldSave) => {
        let lines = [...this.props.lines]
        lines[index] = { ...line, ...data }
        if (lines[index].IsDeleted === true) lines.splice(index, 1)
        this.props.bubbleUpChange({ Lines: lines })
        if (shouldSave === true) saveLine(lines[index]) // save immediatly if it was a checkbox
      }

      const saveLine = (overWriteObj = undefined) => {
        let data = overWriteObj || line
        data.AmountPrUnit = reverseFormatCurrency2(data.AmountPrUnit)
        this.props.postLine(data).then((res) => {
          changeLineData(res.data)
          // window.toastr.success(translation(893), translation('13424'))
        }, () => {
          window.toastr.error(translation(960), translation('216'))
        })
      }

      const deleteLine = () => this.props.onDelete(ESGLevelTypes.Line, line.Id, () => saveLine({ ...line, IsDeleted: true }))

      const onLineChange = ({ target: { value, name, checked, type } }) => {
        let isCheck = type === 'checkbox'
        changeLineData({ [name]: isCheck ? checked : value }, isCheck)
      }

      switch (scopeType) {
        case ESGScopeTypes.ManualReporting:
          return (
            <TableRow key={index} cols={this.props.cols} className='line'>
              <Text size='s' name='Name' value={line.Name} onChange={onLineChange} onBlur={() => saveLine()} />
              <RemoveButton size='s' onClick={deleteLine} />
            </TableRow>
          )
        case ESGScopeTypes.Default:
          return (
            <TableRow key={index} cols={this.props.cols} className='line'>
              <Text size='s' name='Name' value={line.Name} onChange={onLineChange} onBlur={() => saveLine()} />
              <Text size='s' name='EntryValue' value={line.EntryValue} onChange={onLineChange} onBlur={() => saveLine()} disabled={this.props.hideEntry} />
              <div />
              <Text size='s' name='UnitValue' value={line.UnitValue} onChange={onLineChange} onBlur={() => saveLine()} disabled={this.props.hideUnit} />
              <div />
              <DecimalInput size='s' name='AmountPrUnit' value={line.AmountPrUnit} onChange={onLineChange} onBlur={() => saveLine()} decimals={this.maxDecimals} disabled={this.props.hideAmount} />
              <div />
              <RemoveButton size='s' onClick={deleteLine} />
            </TableRow>
          )
        default:
          throw new Error(`Scope type: ${scopeType} is not implemented!`)
      }
    }

    const renderAddLine = (line) => {
      const addLine = () => {
        let data = { ...line, CategoryId: this.props.categoryId }
        this.props.postLine(data).then((res) => {
          this.props.bubbleUpChange({ Lines: [...this.props.lines, res.data] })
          this.setState({ newLine: { ...this.resetNewLine } })
          // window.toastr.success(translation(18412), translation('13424'))
        }, () => {
          window.toastr.error(translation(18413), translation('216'))
        })
      }

      const onLineChange = ({ target: { value, name, checked, type } }) => {
        this.setState({ newLine: { ...line, [name]: type === 'checkbox' ? checked : value } })
      }
      switch (scopeType) {
        case ESGScopeTypes.ManualReporting:
          return (
            <TableRow cols={this.props.cols} className='line'>
              <Text size='s' name='Name' value={line.Name} onChange={onLineChange} />
              <AddButton size='s' onClick={addLine} />
            </TableRow>
          )
        case ESGScopeTypes.Default:
          return (
            <TableRow cols={this.props.cols} className='line'>
              <Text size='s' name='Name' value={line.Name} onChange={onLineChange} />
              <Text size='s' name='EntryValue' value={line.EntryValue} onChange={onLineChange} disabled={this.props.hideEntry} />
              <div />
              <Text size='s' name='UnitValue' value={line.UnitValue} onChange={onLineChange} disabled={this.props.hideUnit} />
              <div />
              <DecimalInput size='s' name='AmountPrUnit' value={line.AmountPrUnit} onChange={onLineChange} decimals={this.maxDecimals} disabled={this.props.hideAmount} />
              <div />
              <AddButton size='s' onClick={addLine} />
            </TableRow>
          )
        default:
          throw new Error(`Scope type: ${scopeType} is not implemented!`)
      }
    }

    return (
      <div className='line-container'>
        {this.props.lines.map(renderLine)}
        {renderAddLine(this.state.newLine)}
      </div>
    )
  }
}

Lines.propTypes = {
  categoryId: PropTypes.number.isRequired,
  bubbleUpChange: PropTypes.func.isRequired,
  lines: PropTypes.arrayOf(object).isRequired,
  cols: PropTypes.arrayOf(string).isRequired,
  onDelete: PropTypes.func.isRequired,
  hideEntry: PropTypes.bool,
  hideUnit: PropTypes.bool,
  hideAmount: PropTypes.bool,
  scopeType: PropTypes.oneOf(Object.values(ESGScopeTypes)).isRequired
}

export default connect(null, { postLine })(Lines)



// WEBPACK FOOTER //
// ./src/app/pages/ESG/Chain/View/components/lines.js